import { useEffect, useState } from 'react';
import vehiclesService from '@/services/vehicles/vehiclesService';

/** Referenser som redan finns hos kundens toppnod, för en organisation. */
export function useVehicleReferenceNames(organizationId: string | number | null | undefined): string[] {
  const [names, setNames] = useState<string[]>([]);
  const id = organizationId != null && String(organizationId) !== '' ? String(organizationId) : '';

  useEffect(() => {
    if (!id) {
      setNames([]);
      return;
    }
    let cancelled = false;
    vehiclesService.getReferenceValues([id]).then((map) => {
      if (!cancelled) setNames(map[id] ?? []);
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  return names;
}
